"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pwd2 = void 0;
const yup_1 = require("yup");
const errors_1 = require("../../errors");
const validation_1 = require("../../validation");
exports.Pwd2 = (firstFieldName = 'pwd') => (target, propertyKey) => validation_1.Validation.registerCustomValidation(target, propertyKey, yup_1.string()
    .oneOf([yup_1.ref(firstFieldName)], errors_1.FormError.notMatchedPasswords)
    .required(errors_1.FormError.required));
//# sourceMappingURL=pwd2.decorator.js.map